import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/central-notificacao";

/**
 * Classe de gerenciamento de chamadas da API do módulo CentralNotificacao
 *
 * @class
 */
export default class CentralNotificacaoApi {
    /**
     * Instância da dependência da API (ofetch)
     */
    private api: $Fetch;

    /**
     * Cria uma nova instância da classe CentralNotificacaoApi.
     * @constructor
     * @param api - Instância da dependência da API (ofetch).
     */
    constructor(api: $Fetch) {
        this.api = api;
    }

    /**
     * Retorna todos os usuários cadastrados.
     */
    GetAllUser() {
        return this.api<ApplicationModule[]>(
            `${controller}/GetAllUser`,
            { method: "GET" }
        );
    }

    /**
     * Retorna um usuário pelo código.
     * @param codUsuario - Código do usuário
     */
    GetByCode(codUsuario: number) {
        return this.api<ApplicationModule>(
            `${controller}/GetByCode`,
            {
                method: "GET",
                params: { codUsuario }
            }
        );
    }

    /**
     * Retorna todos os grupos de usuários.
     */
    GetGrupoUsuario() {
        return this.api<ApplicationModule[]>(
            `${controller}/GetGrupoUsuario`,
            { method: "GET" }
        );
    }

    /**
     * Retorna todas as notificações cadastradas.
     */
    GetAllNotificacoes() {
        return this.api<Notificacao[]>(
            `${controller}/GetAllNotificacoes`,
            {
                method: "GET"
            }
        );
    }

    /**
     * Retorna todas os Serviços de notificações cadastradas.
     */
    GetAllServiceNotifications(dataInicio: string, dataFim: string) {
        return this.api<Notificacao[]>(
            `${controller}/GetAllServiceNotifications`,
            {
                method: "GET",
                params: {
                    dataInicio,
                    dataFim
                }
            }
        );
    }

    /**
     * Retorna o status atual do monitoramento de notificações.
     */
    Status() {
        return this.api<{ emExecucao: boolean }>(
            `${controller}/status`,
            { method: "GET" }
        );
    }

    /**
     * Salva uma nova notificação.
     * @param notificacao - Objeto de notificação
     */
    Salvar(notificacao: Notificacao) {
        return this.api<Notificacao>(
            `${controller}/Salvar`,
            {
                method: "POST",
                body: notificacao
            }
        );
    }

    /**
     * Inicia o monitoramento de notificações.
     */
    Iniciar() {
        return this.api<{ message: string }>(
            `${controller}/iniciar`,
            { method: "POST" }
        );
    }

    /**
     * Para o monitoramento de notificações.
     */
    Parar() {
        return this.api<{ message: string }>(
            `${controller}/parar`,
            { method: "POST" }
        );
    }

    /**
     * Atualiza o status de uma notificação.
     * @param notificacao - Objeto de notificação com status atualizado
     */
    UpdateStatus(notificacao: Notificacao): Promise<any> {
        return this.api<Notificacao>(
            `${controller}/UpdateStatus`,
            {
                method: "PUT",
                body: notificacao
            }
        );
    }

    /**
     * Remove uma notificação pelo código.
     * @param codNotificacao - Código da notificação a ser removida
     */
    DeleteNotificacao(codNotificacao: number) {
        return this.api<boolean>(
            `${controller}/DeleteNotificacao/${codNotificacao}`,
            { method: "DELETE" }
        );
    }
}
